import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../utils/mask.js";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const {
        userNameId,
        userLoginId,
        userCpfId,
        vehiclePassagesOperationGroups
    } = useReportFiltersFetch({
        fetchUserNameId: true,
        fetchUserLoginId: true,
        fetchUserCpfId: true,
        fetchVehiclePassagesOperationGroups: true
    });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        id="analysis"
                        label='Tipo de análise *'
                        isMulti={false}
                        options={[
                            {label: "Resumida por usuário", value: 'user'},
                            {label: "Resumida por placa", value: 'plate'},
                            {label: "Completa", value: 'complete'}
                        ]}
                        value={filters.analysis}
                        onChange={(value) => setFilters(prev => ({...prev, analysis: value}))}
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <SelectComponent
                        id="groups"
                        label='Grupo de operação'
                        isMulti={true}
                        options={vehiclePassagesOperationGroups}
                        value={filters.groups}
                        onChange={(value) => setFilters(prev => ({...prev, groups: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <InputForm
                        id="plate"
                        label="Placa"
                        value={filters.plate}
                        mask={MaskDefault.plateNoRestrict}
                        onChange={({target}) => setFilters(prev => ({ ...prev, plate: target.value?.toUpperCase() }))}
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <AccessForm filters={filters} setFilters={setFilters} customUserNameOptions={userNameId} customUserLoginOptions={userLoginId} customUserCpfOptions={userCpfId}/>

                </form>
            </div>
        </>
    );
};

export default Filters;